<script setup lang="ts">
import { useLocationSelector } from "@/composables/location";
import { getTimeZoneShortCode } from "@/utils/dateTimeFormats";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

dayjs.extend(timezone);

export interface Props {
  range: string;
  timeZone?: string;
}

const props = defineProps<Props>();
const { t } = useI18n();
const { isUsingMultipleTimezones } = useLocationSelector();

const isInMatchingTimezone = computed(() => {
  if (!props.timeZone) {
    return true;
  }
  return (
    !isUsingMultipleTimezones.value &&
    dayjs().format("ZZ") == dayjs().tz(props.timeZone).format("ZZ")
  );
});
</script>

<template>
  <i18n-t
    scope="global"
    keypath="format.withTimeZone"
    tag="span"
  >
    <template #range>
      <span class="range">{{ range }}</span>
    </template>
    <template #timeZoneSuffix>
      <span
        v-if="!isInMatchingTimezone"
        class="tz"
      >
        {{
          t("format.timeZoneSuffix", {
            timeZone: getTimeZoneShortCode(timeZone ?? dayjs.tz.guess()),
          })
        }}
      </span>
    </template>
  </i18n-t>
</template>

<style lang="scss" scoped>
.tz {
  color: var(--so-text-color-secondary);
}
</style>
